export type DevicePlatform = 'linux' | 'windows' | 'mac' | 'android' | 'ios' | 'unknown';

export const getDevicePlatform = (): DevicePlatform => {
  const agent = navigator.userAgent;
  // iPads can identify as Macs when requesting desktop websites.
  if (/iPhone|iPad|iPod/i.test(agent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) return 'ios';
  if (/Android/i.test(agent)) return 'android';
  if (/Windows/i.test(agent)) return 'windows';
  if (/Macintosh|Mac OS X/i.test(agent)) return 'mac';
  if (/Linux/i.test(agent) && !/CrOS/i.test(agent)) return 'linux';
  return 'unknown';
};
